import { IPortalEvent } from './types';

export const convertEvent = ({
  ...data
}: IPortalEvent<string>): IPortalEvent<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
